<template>
	<div>
		<TopHeader :tabIndex='tabIndex'></TopHeader>

		<div class="cont">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div class="flex-only" style="margin-top: 20px;">
				<el-image style="width: 507px;height: 284px;border-radius: 13px;" :src="detail.img" :preview-src-list="$getImageList(detail.img)">
				</el-image>
				<!-- <img :src="detail.img" style="width: 507px;height: 284px;border-radius: 13px;" /> -->
				<div class="right flex-1">
					<div class="flex flex-b">
						<div class="name">{{detail.name}}</div>
						<img class="pointer" @click="delCollect()" src="../../assets/icon/sc.png"
							v-if="detail.isCollect" style="width: 27px;height: 27px;" alt="" />
						<img class="pointer" @click="addCollect()" src="../../assets/icon/wsc.png" v-else
							style="width: 27px;height: 27px;" alt="" />
					</div>
					<div class="flex">
						<div class="flag flex flex-c">{{detail.course_cate_name}}</div>
					</div>
					<div class="lbox">
						<div class="flex flex-b">
							<div class="t1">当前已选 {{selAllChapter}}个章节</div>
							<div class="vip" v-if="loginUser.member">{{loginUser.member?loginUser.member.name:''}}</div>
						</div>
						<div class="flex" style="margin-top: 10px;">
							<div class="t2">{{selAllScore}}<span>积分</span></div>
							<div class="t3">{{totalScore}}积分</div>
						</div>
					</div>
					<div class="flex" v-if="loginUser.member.is_fee!=1">
						<div class="wxbtn pointer" @click="addCart(detail)">加入购物车</div>
						<div class="login-btn pointer" @click="buyNow(detail)">
							<span class="text">立即购买</span>
						</div>
					</div>
					<div class="flex" v-else>
						<div class="login-btn pointer" @click="navIndex=1">
							<span class="text">立即观看</span>
						</div>
					</div>
				</div>
			</div>
			<div class="navs flex">
				<div class="navItem pointer" :class="navIndex==0?'active':''" @click="navIndex=0">课程详情</div>
				<div class="navItem pointer" :class="navIndex==1?'active':''" @click="navIndex=1">课程章节</div>
			</div>
			<template v-if="navIndex==0">
				<div class="titles">课程介绍</div>
				<div class="detailHtml" v-html="detail.desc"></div>
				<div class="titles">课程大纲</div>
				<div class="lbox">
					<div class="flex-only botl" v-for="(item,i) in detail.chapter">
						<div class="num">第{{i+1}}章</div>
						<div class="ml20">
							<div class="name">{{item.name}}</div>
							<div class="det">{{item.desc}}</div>
						</div>
					</div>
				</div>
				<div class="titles">相关课程推荐</div>
				<div class="flex">
					<div class="itembg pointer" v-if='index<4' @click="toCourseDetail(item)"
						v-for="(item,index) in recommend">
						<img :src="item.img" style="width: 100%;border-radius: 13px;" />
						<div class="ititle">{{item.name}}</div>
						<div class="price flex" style="margin-top: 12px;">{{item.score}}
							<div class="span">积分</div>
						</div>
					</div>
				</div>
				<div class="titles">学员评价</div>
				<div class="comment flex-only">
					<div class="item" v-for="(item,index) in courseEvaluateList" :key="index">
						<div class="flex flex-b">
							<div class="flex">
								<img :src="item.user.img" style="width: 53px;height: 53px;border-radius: 50%;" alt="" />
								<div class="" style="margin-left: 10px;">
									<div class="flex">
										<div class="name">{{item.user?item.user.name:''}}</div>
										<div class="vip1">{{item.user?item.user.member_name:''}}</div>
									</div>
									<div class="time">{{item.create_time}}</div>
								</div>
							</div>
							<div class="flex number pointer">
								<img src="../../assets/images/icon/icdz.png" v-if="item.is_agree==1"
									@click="CourseOrderEvaluateAgree(item,2)"
									style="width: 16px;height: 16px;margin-right: 6px;" alt="" />
								<img src="../../assets/images/icon/icwdz.png" v-else
									@click="CourseOrderEvaluateAgree(item,1)"
									style="width: 16px;height: 16px;margin-right: 6px;" alt="" />
								{{item.agree}}
							</div>
						</div>
						<div class="flex flex-b mt20">
							<div class="flex">
								<img src="../../assets/images/icon/start.png" v-for="_item in parseInt(item.star)"
									style="margin-right: 5px; width: 16px;height: 16px;" alt="" />
							</div>
							<div class="tip" v-if="item.chapter_order_num ==item.chapter_num">#已购全部章节</div>
							<div class="tip" v-else>#已购 {{item.chapter_order_num}} 章节</div>
						</div>
						<div class="det">{{item.content}}</div>
					</div>
				</div>
				<!-- <pagination :total='courseEvaluateCount' @currentChange="currentChange"></pagination> -->
			</template>
			<template v-if="navIndex==1">
				<div class="tit"><span>*</span>请勾选要购买的章节（如需整章购买，请直接点击“整课购买”)</div>
				<div class="flex-only">
					<div class="flex-2">
						<div class="lbox flex" v-for="(item,index) in chapter" style="padding: 30px;margin-top: 10px;">
							<img class="pointer" src="../../assets/icon/wxz.png"
								v-if="item.selStatus==0 && item.is_buy!=1" @click="selectStatusClick(item,1)"
								style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
							<img class="pointer" src="../../assets/icon/xz.png"
								v-if="item.selStatus == 1 && item.is_buy!=1" @click="selectStatusClick(item,0)"
								style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
							<div class="flex-1">
								<div class="flex flex-b" style="margin-bottom: 14px;">
									<div class="flex">
										<div class="num">{{item.name}}</div>
										<div class="name" style="margin-left: 16px;">{{item.desc}}</div>
									</div>
									<div class="long" v-if="item.type==1">
										{{parseFloat(item.file.second/60).toFixed(1)<=1?parseFloat(item.file.second)+'秒':parseFloat(item.file.second/60).toFixed(1)+'分钟'}}/视频
									</div>
									<div class="long" v-if="item.type==2">
										{{parseFloat(item.file.second/60).toFixed(1)<=1?parseFloat(item.file.second)+'秒':parseFloat(item.file.second/60).toFixed(1)+'分钟'}}/音频
									</div>
									<div class="long" v-if="item.type==3">PDF</div>
									<div class="long" v-if="item.type==4">PPT</div>
								</div>
								<div class="flex flex-b">
									<div class="flex">
										<div class="vip1" style="margin: 6px 0 0 0;" v-if="loginUser.member">
											{{loginUser.member?loginUser.member.name:''}}
										</div>
										<!-- <div class="vip2" style="margin: 6px 0 0 0;">星光银</div> -->
										<!-- <div class="score">
											{{item.score-parseInt(loginUser.member?loginUser.member.discount:0)}}<span>积分</span>
										</div> -->
										<div class="score">
											{{item.score}}<span>积分</span>
										</div>
										<div class="linePrice">{{item.score}}积分</div>
									</div>
									<div v-if="loginUser.member.is_fee!=1">
										<div class="wxbtn pointer" @click="toTryStudyClick(item)"
											v-if="item.is_see==1 && item.is_buy==0"
											style="width: 87px;height: 36px;margin-top: 0;">
											<span>试看</span>
											<img src="../../assets/icon/jt.png"
												style="width: 9px;height: 11px;margin-left: 10px;" alt="" />
										</div>
										<div class="ygmBtn flex flex-c" @click="toStudyClick1(item)"
											v-if="item.is_buy==1">已购买</div>
									</div>
									<div class="wxbtn pointer" @click="toStudyClick(item)" v-else
										style="width: 87px;height: 36px;margin-top: 0;">
										<span>立即观看</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="allBuy flex-1">
						<div>
							<div class="flex flex-b">
								<div class="t1">整课购买</div>
								<div class="t2">{{detail.score}}<span>积分</span></div>
							</div>
							<div class="flex flex-b" style="margin-top: 14px;">
								<div class="t3">{{loginUser.member?loginUser.member.name:''}}优惠</div>
								<div class="t4">-{{loginUser.member.discount||0}}<span>积分</span></div>
							</div>
						</div>
						<div class="allBtn flex flex-c pointer" @click="buyAllClick">
							整课购买</div>
					</div>
				</div>
			</template>
		</div>
		<div class="toTop" v-if="showBackToTop" @click="scrollToTop"></div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Utils from "@/jslibs/utils";
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import {
		getCourseDetail,
		addCollect,
		delCollect,
		getCourse,
		CourseOrderEvaluateAgree,
		getCourseOrderEvaluate
	} from "@/api/course";
	import {
		addCart
	} from "@/api/cart";
	import TopHeader from "../../components/TopHeader.vue";
	import Footer from "../../components/Footer.vue";
	import Breadcrumb from "../../components/Breadcrumb.vue";
	import Pagination from "../../components/Pagination.vue";
	export default {
		data() {
			return {
				recommend: [],
				navIndex: 0,
				showBackToTop: false, // 控制按钮的显示
				pathList: [{
					title: '课程列表',
					path: '/course'
				}, {
					title: '线割机操作进阶',
					path: ''
				}],
				id: '',
				tabIndex: 1,
				detail: '',
				chapter: '',
				courseIdArry: [],
				loginUser: {
					member: {}
				},
				courseList: [],
				courseEvaluateList: [],
				courseEvaluateCount: 0,
				selAllChatperList: [],
				selAllChapter: 0,
				selAllScore: 0,
				totalScore: 0
			}
		},
		components: {
			TopHeader,
			Footer,
			Breadcrumb,
			Pagination
		},
		watch: {
			'$route.query.id'(newVal, oldVal) {
				this.id = newVal
				this.getCourseDetail()
				this.getCourseOrderEvaluate()
			}
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
			this.id = this.$route.query.id
			this.getCourseDetail()
			if (this.$route.query.source == 'home') {
				this.pathList[0].title = '首页'
				this.pathList[0].path = '/index'
				this.tabIndex = 0
			}
			// this.getCourse()
			this.getCourseOrderEvaluate()
			window.addEventListener('scroll', this.handleScroll)
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			async CourseOrderEvaluateAgree(item, agree) {
				const {
					status,
					data
				} = await CourseOrderEvaluateAgree({
					course_order_uuid: item.course_order_uuid,
					agree: agree
				});
				item.is_agree = agree
				const sum = agree == 1 ? 1 : -1
				item.agree += sum
			},
			toTryStudyClick(item) {
				if (item.type == 1) {
					//视频
					this.$router.push({
						path: '/studyVideo?chapterId=' + item.uuid + '&courseId=' + this.detail.uuid
					})
				}
				if (item.type == 2) {
					//音频
					this.$router.push({
						path: '/studyVideo?chapterId=' + item.uuid + '&courseId=' + this.detail.uuid
					})
				}
				if (item.type == 3 || item.type == 4) {
					//pdf/ppt
					window.open('http://api.idocv.com/view/url?url=' + item.fee_file.url)
				}
			},
			toStudyClick(item) {
				if (item.type == 1) {
					//视频
					this.$router.push({
						path: '/studyVideo?chapterId=' + item.uuid + '&courseId=' + this.detail.uuid
					})
				}
				if (item.type == 2) {
					//音频
					this.$router.push({
						path: '/studyVideo?id=' + item.uuid
					})
				}
				if (item.type == 3 || item.type == 4) {
					//pdf/ppt
					window.open('http://api.idocv.com/view/url?url=' + item.file.url)
				}
			},
			toStudyClick1(item){
				this.$router.push({
					path: '/myCourseDetail',
					query: {
						id: item.course_uuid,
						course_cate_name: item.course_cate_name
					}
				})
			},
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
			},
			//整课购买
			buyAllClick() {
				this.$router.push('/courseBuy?id=' + this.detail.uuid + '&buyAll=1' + '&course_cate_name=' + this
					.$route.query.course_cate_name)
			},

			selectStatusClick(item, status) {
				this.$set(item, 'selStatus', status)
				let selArrs = []
				let scores = []
				this.chapter.forEach(_item => {
					if (_item.selStatus == 1) {
						selArrs.push(_item)
						scores.push(parseInt(_item.score))
					}
				})
				this.selAllChapter = selArrs.length
				this.selAllChatperList = selArrs
				if (scores.length > 0) {
					// this.selAllScore = scores.reduce((a, b) => a + b) - parseInt(this.loginUser.member ? this.loginUser
					// 	.member.discount : 0) * selArrs.length
					this.selAllScore = scores.reduce((a, b) => a + b)
					this.totalScore = scores.reduce((a, b) => a + b)
				}
			},
			async getCourseOrderEvaluate() {
				const {
					status,
					data
				} = await getCourseOrderEvaluate({
					course_uuid: this.id,
					page_index: 1,
					page_size: 99
				});
				this.courseEvaluateList = data.result.data
				this.courseEvaluateCount = data.result.total
			},
			toCourseDetail(item) {
				this.$router.push({
					path: '/courseDetail',
					query: {
						id: item.uuid,
						course_cate_name: item.course_cate_name
					}
				})
			},
			async addCart(detail) {
				this.chapter.forEach(item => {
					this.courseIdArry.push(item.uuid);
				});
				const {
					status,
					data
				} = await addCart({
					chapter_uuid: this.courseIdArry
				})
				this.courseIdArry = []
				this.$message({
					message: "加入成功",
					type: "success"
				});
			},
			buyNow(detail) {
				if (this.selAllChatperList.length != 0) {
					Utils.setCookie("buyChapters", JSON.stringify(this.selAllChatperList), 1)
					if (this.selAllChatperList.length == this.detail.chapter.length) {
						this.$router.push('/courseBuy?id=' + this.detail.uuid +
							'&buyAll=1' + '&course_cate_name=' + this.$route.query.course_cate_name)
					} else {
						this.$router.push('/courseBuy?id=' + this.detail.uuid +
							'&buyAll=0' + '&course_cate_name=' + this.$route.query.course_cate_name)
					}

				} else {
					this.$message({
						message: "请选择要购买的章节",
						type: "warning"
					});
				}
			},
			async addCollect() {
				const {
					status,
					data
				} = await addCollect({
					course_uuid: this.id
				})
				this.getCourseDetail()
			},
			async delCollect() {
				const {
					status,
					data
				} = await delCollect({
					uuid: this.id,
				})
				this.getCourseDetail()
			},
			async getCourseDetail() {
				const {
					status,
					data
				} = await getCourseDetail({
					uuid: this.id,
				});
				this.detail = data.result
				this.recommend = data.result.recommend
				this.chapter = this.detail.chapter
				this.chapter.forEach(item => {
					this.$set(item, 'selStatus', 0)
				})
				this.pathList[1].title = this.detail.name
			},
			async getCourse() {
				const {
					status,
					data
				} = await getCourse({
					page_inde: 1,
					page_size: 4,
					is_quality: 1
				});
				this.courseList = data.result.data
			},
			handleScroll() {
				// 当滚动到距离底部100px时显示按钮（可根据需求调整）
				const scrollY = window.scrollY
				const visibleHeight = document.documentElement.clientHeight
				const pageHeight = document.documentElement.scrollHeight
				this.showBackToTop = (scrollY + visibleHeight) > (pageHeight + 1000)
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
			//改变页数
			currentChange(e) {
				console.log(e)
			},
		}
	}
</script>

<style lang="less" scoped>
	.toTop {
		position: fixed;
		right: 190px;
		bottom: 143px;
		background: url('../../assets/images/home/top.png') no-repeat;
		width: 53px;
		height: 53px;
		z-index: 9999;
		background-size: 100% 100%;
		cursor: pointer;
	}

	::v-deep .el-breadcrumb__inner.is-link:hover {
		color: #000;
	}

	::v-deep .is-link {
		color: #999 !important;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
	}

	::v-deep .el-breadcrumb__separator {
		font-size: 16px !important;
	}

	::v-deep .el-breadcrumb__inner {
		a {
			font-size: 16px !important;
			color: #000 !important;
			font-weight: 500 !important;
		}
	}

	::v-deep .el-breadcrumb__item {
		float: none;
	}

	.cont {
		padding: 30px 133px 0;

		.el-icon-star-off,
		.el-icon-star-on {
			width: 50px;
		}

		.right {
			margin-left: 20px;

			.name {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 27px;
				color: #000000;
			}

			.flag {
				margin: 10px 0;
				height: 22px;
				padding: 0 10px;
				background: rgba(0, 167, 60, 0.06);
				border-radius: 4px 4px 4px 4px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
			}

			.lbox {
				width: 30%;
				border-radius: 9px 9px 9px 9px;
				border: 1px solid #EEEEEE;
				padding: 20px;
				margin: 20px 0;

				.t1 {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #000000;
				}

				.vip {
					height: 22px;
					line-height: 22px;
					padding: 0 10px;
					background: rgba(215, 177, 85, 0.06);
					border-radius: 4px 4px 4px 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #D7B155;
				}

				.t2 {
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 22px;
					color: #00A73C;

					span {
						margin-left: 6px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #00A73C;
					}
				}

				.t3 {
					padding-top: 10px;
					margin-left: 14px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #CCCCCC;
					text-decoration-line: line-through;
				}
			}
		}

		.login-btn {
			margin-top: 10px;
			width: 164px;
			height: 50px;
			background: url('../../assets/images/course/btnw164.png') no-repeat;
			background-size: 100% 100%;
			display: flex;
			align-items: center;
			justify-content: center;

			.text {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 16px;
				text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
				text-align: center;
				font-style: normal;
				text-transform: none;
				background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
		}

		.wxbtn {
			margin-top: 10px;
			width: 164px;
			height: 44px;
			border-radius: 12px 12px 12px 12px;
			border: 2px solid rgba(127, 218, 76, .24);
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		.navs {
			margin: 30px 0;
			justify-content: center;
			border-top: 1px solid #EEEEEE;
			border-bottom: 1px solid #EEEEEE;

			.navItem {
				margin: 0 80px;
				line-height: 60px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 20px;
				color: #666666;
			}

			.active {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: bold;
				font-size: 20px;
				color: #000000;
				position: relative;

				&::after {
					position: absolute;
					content: '';
					bottom: 0;
					left: 0;
					width: 100%;
					height: 4px;
					background: #00A73C;
				}
			}
		}

		.lbox {
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			.botl {
				padding: 16px 0;
				border-bottom: 1px solid #EEEEEE;

				.ml20 {
					margin-left: 20px;
				}

				.det {
					margin-top: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #666666;
				}
			}

			.num {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #999999;
				white-space: nowrap;
			}

			.name {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}

			.time {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
			}
		}

		.itembg {
			width: calc(25% - 27px);
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 9px 11px;
			margin-right: 20px;

			.ititle {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				margin-top: 13px;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
			}

			.price {
				font-family: DINPro, DINPro;
				font-weight: bold;
				font-size: 22px;
				color: #00A73C;

				.span {
					margin-left: 2px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #00A73C;
					margin-top: 5px;
				}
			}
		}

		.comment {
			overflow-x: scroll;
			padding: 10px 10px 20px;

			.item {
				min-width: 383px;
				margin-right: 27px;
				background: #FFFFFF;
				box-shadow: 3px 3px 13px 3px rgba(0, 0, 0, 0.06);
				border-radius: 13px 13px 13px 13px;
				padding: 30px;

				.name {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 16px;
					color: #000000;
				}

				.time {
					margin-top: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
				}

				.number {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
				}

				.mt20 {
					margin-top: 12px;
				}

				.tip {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #00A73C;
				}

				.det {
					margin-top: 14px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					max-width: 350px;
					word-break: break-all;
				}
			}
		}

		.tit {
			margin-bottom: 20px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #999;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #FC5F5F;
			}
		}

		.vip1 {
			margin-left: 10px;
			height: 22px;
			background: rgba(215, 177, 85, 0.06);
			border-radius: 4px 4px 4px 4px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #D7B155;
			line-height: 22px;
			padding: 0 10px;
		}

		.vip2 {
			margin-left: 10px;
			height: 22px;
			background: rgba(191, 201, 210, 0.06);
			border-radius: 8px 8px 8px 8px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #99A7B5;
			line-height: 22px;
			padding: 0 10px;
		}

		.long {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
			white-space: nowrap;
		}

		.ygmBtn {
			width: 87px;
			line-height: 36px;
			height: 36px;
			background: #CCCCCC;
			border-radius: 11px 11px 11px 11px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #FFFFFF;
		}

		.allBuy {
			margin-top: 10px;
			margin-left: 20px;
			min-height: 100%;
			background: linear-gradient(360deg, #FBFAF6 0%, #FBF6EA 100%);
			box-shadow: 0px 3 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 20px;
				color: #333333;
			}

			.t2 {
				font-family: DINPro, DINPro;
				font-weight: bold;
				font-size: 22px;
				color: #333333;

				span {
					margin-left: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
				}
			}

			.t3 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #D7B155;
			}

			.t4 {
				font-family: DINPro, DINPro;
				font-weight: 500;
				font-size: 18px;
				color: #D7B155;

				span {
					margin-left: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #D7B155;
				}
			}

			.allBtn {
				height: 40px;
				background: linear-gradient(136deg, #7FDA4C 0%, #10B649 100%);
				border-radius: 11px 11px 11px 11px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 40px;
			}
		}
	}

	::v-deep .detailHtml {
		p {
			img {
				width: 100%;
				height: auto;
			}
		}
	}
</style>